<template>
  <div class="row">
    <div class="col-lg-9 d-flex pr-md-0">
      <div class="row total-stats-block" data-keyload="middle_row_now_count">
        <div class="pearls row col-lg-12 pt-20 panel pb-20">
          <div class="pearl col-lg-3" v-for="(stat, type) in stats" :class="stat.class">
            <div v-if="stat.error" class="pearl-icon">
              <i class="fa fa-exclamation-triangle pearl-blue" aria-hidden="true"></i>
            </div>

            <div v-if="!stat.error && stat.loading" class="pearl-icon">
              <i class="fa fa-spinner fa-pulse pearl-blue" aria-hidden="true"></i>
            </div>

            <div v-if="!stat.error && !stat.loading" class="pearl-icon" :style="stat.font_style">
              {{ stat.count }}
            </div>
            <span class="pearl-title">
              <span v-html="stat.title"></span>
            </span>
          </div>
        </div>
      </div>
    </div>

    <div class="col-lg-3">
      <div class="row" style="height:100%;">
        <div class="pearls row col-lg-12 pt-20 panel pb-20">
          <div class="pearl col-lg-12 red active" aria-expanded="true" data-keyload="color_status_count_not_completed_exam_user4group">
            <a href="/q/learncontrol/all_stat_persons4groups?externvar[student_control_type]=4&externvar[def_is_active_group]=50" target="_self">

              <span v-if="not_finished_learning.error" class="pearl-icon cursor-pointer">
                <i class="fa fa-exclamation-triangle pearl-red" aria-hidden="true"></i>
              </span>

              <span v-if="!not_finished_learning.error && not_finished_learning.loading" class="pearl-icon cursor-pointer">
                <i class="fa fa-spinner fa-pulse pearl-red" aria-hidden="true"></i>
              </span>

              <span v-if="!not_finished_learning.error && !not_finished_learning.loading" class="pearl-icon cursor-pointer" :style="not_finished_learning.font_style">
                {{ not_finished_learning.count }}
              </span>
            </a>
            <span class="pearl-title">
                <span v-html="not_finished_learning.title"></span>
                <i class="icon md-help-outline cursor-pointer"
                   aria-hidden="true"
                   data-toggle="popover"
                   data-html="true"
                   data-trigger="click | hover"
                   data-content="Рассчитывается на основании человек-группа"></i>
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TopCountsPanel',
  data() {
    return {
      stats                : {
        'total_count'         : {
          loading   : true,
          error     : false,
          count     : 0,
          title     : 'Общее количество<br />назначенных курсов',
          font_style: '',
          class     : 'active',
        },
        'not_started_learning': {
          loading   : true,
          error     : false,
          count     : 0,
          title     : 'Курсы, к которым<br />еще не приступили',
          font_style: '',
          class     : '',
        },
        'started_learning'    : {
          loading   : true,
          error     : false,
          count     : 0,
          title     : 'Курсы, по которым<br />начали обучение',
          font_style: '',
          class     : '',
        },
        'finished_learning'   : {
          loading   : true,
          error     : false,
          count     : 0,
          title     : 'Курсы, по которым<br />сдали экзамен',
          font_style: '',
          class     : '',
        },
      },
      not_finished_learning: {
        loading   : true,
        error     : false,
        count     : 0,
        title     : 'Не завершили обучение<br />в установленные сроки',
        font_style: '',
      },
    };
  },
  methods: {
    get_data() {
      axios.get('/widgets/TopCountsPanel').then((response) => {
        Object.keys(this.stats).map((type) => {
          this.stats[type].count = response.data[type];
          this.stats[type].font_style = this.font_size(response.data[type]);
          this.stats[type].loading = false;
        });

        this.not_finished_learning.count = response.data.not_finished_learning;
        this.not_finished_learning.font_style = this.font_size(response.data.not_finished_learning);
        this.not_finished_learning.loading = false;
      }).catch((err) => {
        console.log(err);
        Object.keys(this.stats).map((type) => {
          this.stats[type].error = true;
        });
        this.not_finished_learning.error = true;
      });
    },
    font_size(content) {
      const len = content.toString().length;

      const styles = {
        4: 'font-size: 11pt !important;',
        5: 'font-size: 9pt !important;',
      };

      return Object.keys(styles).indexOf(len.toString()) !== -1 ? styles[len] : '';
    },
  },
  mounted() {
    this.get_data();
  },
};
</script>

<style scoped>
.md-help-outline {
  color: #ff6611;
}

.fa {
  font-size: 18px;
}

.fa.pearl-blue {
  color: #3f51b5;
}

.fa.pearl-red {
  color: #b53f51;
}
</style>
